export interface Interno{
    id: number,
    text: string
}

export class UsuariosInternosService{
    /**
     *
     */
    /**
     *
     */
    constructor(private baseUrl: string){};
    GetNames = async (idPlantilla: string):Promise<Interno[]>=>{
        try{

            let response = await fetch(`${this.baseUrl}/PlantillaFormulario/ObtenerUsuariosInternos?plantillasId=${idPlantilla}`)
            if(response.status == 401){
                Notify.error("Su sesión ha finalizado");
                throw "Su sesión ha finalizado";
            }
            if(response.status >400){
                Notify.error("Error al obtener usuarios internos");
                throw "Error al obtener usuarios internos";
            }
            let internos = <Interno[]>await response.json();
            return internos;
        }catch(ex){
            Notify.error("Error al obtener usuarios internos");
        }
        
    }
}